import { render, staticRenderFns } from "./AnggotaPusatSelect.vue?vue&type=template&id=0323a7fe&scoped=true"
import script from "./AnggotaPusatSelect.vue?vue&type=script&lang=js"
export * from "./AnggotaPusatSelect.vue?vue&type=script&lang=js"
import style0 from "./AnggotaPusatSelect.vue?vue&type=style&index=0&id=0323a7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0323a7fe",
  null
  
)

export default component.exports